import * as React  from 'react'
import { connect } from 'react-redux'

import Grid      from '@material-ui/core/Grid'

import { api }                       from '../../client'
import {
  communicationToUiState,
  communicationWasSuccessful,
}                                        from '../../project-utils'
import {
  ApplicationState,
  companiesGetRequest,
  createCompanyRequest,
  editCompanyRequest,
  selectCompanies,
}                                        from '../../redux'
import { SearchField }                   from '../atoms'
import CreateCompanyForm                 from '../forms/CompanyCreateForm'
import CompanyEditForm                   from '../forms/CompanyEditForm'
import withValue, { InjectedValueProps } from '../hocs/withValue'
import { CompaniesBar, CompanyList }     from '../molecules'

const mstp = (state: ApplicationState) => ({
  state,
  companies:                     selectCompanies(state),
  createCompanyCommunication:    createCompanyRequest.communicationSelector(state),
  editCompanyCommunication:      editCompanyRequest.communicationSelector(state),
  requestCompaniesCommunication: companiesGetRequest.communicationSelector(state),
})

const actions = {
  getCompanies:  companiesGetRequest.actionCreator,
  createCompany: createCompanyRequest.actionCreator,
  editPersonal:  editCompanyRequest.actionCreator,
}

const initState = {
  createFormIsOpen:     false,
  editFormIsOpen:       false,
  companyBeingEditedId: 0,
}

type CompaniesProps =
  ReturnType<typeof mstp>
  & typeof actions
  & InjectedValueProps

class Companies extends React.Component<CompaniesProps, typeof initState> {
  public state = initState

  private readonly exportRequest = api.exportCompanies()

  public componentDidUpdate (lastProps: CompaniesProps) {
    if (
      communicationWasSuccessful(
        lastProps.createCompanyCommunication,
        this.props.createCompanyCommunication,
      )
    ) {
      this.toggleCreateFormOpen()
    }

    if (
      communicationWasSuccessful(
        lastProps.editCompanyCommunication,
        this.props.editCompanyCommunication,
      )
    ) {
      this.toggleEditFormOpen()
    }
  }

  public componentDidMount () {
    this.props.getCompanies()
  }

  public render () {
    return (
      <Grid
        container
        direction={'column'}
        spacing={16}
      >
        <Grid item>
          {this.renderControls()}
          {this.renderCreateCompanyForm()}
        </Grid>
        <Grid item>
          {this.renderSearch()}
        </Grid>
        <Grid item>
          {this.renderCompanyList()}
          {this.renderEditCompanyForm()}
        </Grid>
      </Grid>
    )
  }

  private renderControls = () => {
    return (
      <CompaniesBar
        exportRequest={this.exportRequest}
        onAddClick={this.toggleCreateFormOpen}
      />
    )
  }

  private renderSearch = () => {
    return (
      <SearchField
        onChange={this.props.handleChange}
        value={this.props.value}
      />
    )
  }

  private renderCreateCompanyForm = () => {
    const { createCompanyCommunication } = this.props

    return (
      <CreateCompanyForm
        {...createCompanyCommunication}
        onSubmit={this.create}
        isOpen={this.state.createFormIsOpen}
        close={this.toggleCreateFormOpen}
      />
    )
  }

  private renderEditCompanyForm = () => {
    const { editCompanyCommunication, companies } = this.props
    const { companyBeingEditedId, editFormIsOpen } = this.state

    const companyBeingEdited = companies
      .find(({ id }) => id === companyBeingEditedId)

    return (
      <CompanyEditForm
        {...editCompanyCommunication}
        values={companyBeingEdited}
        onSubmit={this.edit}
        isOpen={editFormIsOpen}
        close={this.toggleEditFormOpen}
      />
    )
  }

  private renderCompanyList = () => {
    const {
      requestCompaniesCommunication,
      companies,
      editCompanyCommunication,
    } = this.props

    const ui = communicationToUiState(requestCompaniesCommunication)

    return (
      <CompanyList
        filterValue={this.props.value}
        companies={companies}
        isCached={!!companies.length}
        ui={ui}
        error={requestCompaniesCommunication.error}
        editCommunication={editCompanyCommunication}
        onEditClick={this.onEditClick}
      />
    )
  }

  private create = values => {
    this.props.createCompany(values)
  }

  private onEditClick = (companyId: number) => {
    this.setState({
      companyBeingEditedId: companyId,
      editFormIsOpen:       true,
    })
  }

  private edit = values => {
    const { companyBeingEditedId } = this.state

    this.props.editPersonal(companyBeingEditedId, values)
  }

  private toggleCreateFormOpen = () => {
    this.setState(state => ({
      createFormIsOpen: !state.createFormIsOpen,
    }))
  }

  private toggleEditFormOpen = () => {
    this.setState(state => ({
      editFormIsOpen: !state.editFormIsOpen,
    }))
  }
}

export default connect(mstp, actions)(
  withValue(
    Companies
  )
)



// WEBPACK FOOTER //
// ./src/components/environments/Companies.tsx